var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('p',{staticClass:"labeled-external-link"},[_vm._v(" "+_vm._s(_vm.label)),_c('br'),_c('a',_vm._b({attrs:{"href":_vm.url,"target":"_blank","rel":"noopener noreferrer"}},'a',_vm.$attrs,false),[_vm._v(_vm._s(_vm.url))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }